import React from 'react';
import { ExternalLink, Heart, Calendar, MessageSquare, Instagram, Linkedin, Twitter, Youtube, Sparkles, Layers, Sliders, Settings, Search as SearchIcon, Lock } from 'lucide-react';

export const BiolinkBentoRealMockup: React.FC = () => {
  return (
    <div className="w-full bg-[#7B8EFF] text-slate-900 font-sans border border-slate-200/90 rounded-3xl overflow-hidden shadow-2xl p-6 md:p-10 text-left space-y-8">
      
      {/* 1. MOCKUP BROWSER URL BAR (ESTILO LINKWI BIO LINK 2.0) */}
      <div className="max-w-md mx-auto bg-white border border-slate-200/80 rounded-full py-1.5 px-4 text-center text-xs font-mono text-slate-700 flex items-center justify-center gap-2">
         <span className="w-2 h-2 rounded-full bg-emerald-500" />
         <span>linkwi.com.br/suamarca-oficial</span>
      </div>

      {/* 2. DUAL DISPLAY CONTAINER: HOPP EDITOR SIDEBAR (LEFT) + BENTO.ME GRID (RIGHT) */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
         
         {/* LEFT SIDEBAR: HOPP LINK-IN-BIO EDITOR TOOLS (RECRIAÇÃO DA IMAGEM 4) */}
         <div className="lg:col-span-3 bg-white/95 backdrop-blur-md border border-white/60 rounded-2xl p-3 space-y-4 shadow-sm hidden lg:block">
            <span className="text-[9px] font-black uppercase text-slate-400 tracking-wider px-2 block">Painel de Edição</span>
            <div className="space-y-1 text-xs font-bold text-slate-700">
               {[
                  { label: 'Ações & Links', icon: Sliders, active: true },
                  { label: 'Redes Sociais', icon: Instagram },
                  { label: 'Conteúdo', icon: Layers },
                  { label: 'Design & Tema', icon: Sparkles },
                  { label: 'Busca SEO', icon: SearchIcon },
                  { label: 'Configurações', icon: Settings },
               ].map((item, i) => (
                  <div key={i} className={`flex items-center gap-2 px-3 py-2 rounded-xl transition-colors cursor-pointer ${item.active ? 'bg-[#7B8EFF]/10 text-[#0061FF] border border-[#7B8EFF]/20' : 'hover:bg-slate-100'}`}>
                     <item.icon className="w-3.5 h-3.5" />
                     <span className="text-[11px]">{item.label}</span>
                  </div>
               ))}
            </div>
         </div>

         {/* RIGHT: BENTO.ME REALISTIC CARD GRID (RECRIAÇÃO FIEL DA IMAGEM 5) */}
         <div className="lg:col-span-9 bg-white/95 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-white/60 shadow-xl space-y-6">
            
            {/* PROFILE HEADER & BIO */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 border-b border-slate-100 pb-6">
               <div className="w-20 h-20 rounded-full border-2 border-white shadow-md overflow-hidden shrink-0">
                  <img 
                     src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=300&auto=format&fit=crop" 
                     className="w-full h-full object-cover" 
                     alt="Zoé Williams Avatar" 
                  />
               </div>
               <div className="space-y-1">
                  <h3 className="text-2xl font-heading font-black text-slate-900">Zoé Williams</h3>
                  <p className="text-xs text-slate-600 max-w-md font-medium">
                     Building the products I want to exist in the world. Sharing my journey in design & tech.
                  </p>
               </div>
            </div>

            {/* BENTO GRID OF WIDGETS (REPLICANDO CADA CARD DA IMAGEM 5) */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
               
               {/* Twitter Card */}
               <div className="bg-[#E8F5FE] border border-blue-200/80 p-4 rounded-2xl space-y-2 text-left">
                  <div className="w-7 h-7 rounded-full bg-[#1DA1F2] text-white flex items-center justify-center">
                     <Twitter className="w-3.5 h-3.5" />
                  </div>
                  <strong className="text-xs font-bold text-slate-900 block">My Tweeeets</strong>
                  <button className="bg-[#1DA1F2] hover:bg-blue-500 text-white font-bold text-[10px] px-3 py-1.5 rounded-full transition-colors">
                     Follow
                  </button>
               </div>

               {/* YouTube Card */}
               <div className="bg-[#FFEBEE] border border-rose-200/80 p-4 rounded-2xl space-y-2 text-left">
                  <div className="w-7 h-7 rounded-full bg-[#FF0000] text-white flex items-center justify-center">
                     <Youtube className="w-3.5 h-3.5" />
                  </div>
                  <strong className="text-xs font-bold text-slate-900 block">Hot takes on products</strong>
                  <button className="bg-[#FF0000] hover:bg-red-600 text-white font-bold text-[10px] px-3 py-1.5 rounded-full transition-colors">
                     Subscribe
                  </button>
               </div>

               {/* Support / Donation Card */}
               <div className="bg-purple-50 border border-purple-200/80 p-4 rounded-2xl space-y-2 text-left">
                  <div className="flex justify-between items-center">
                     <span className="text-[10px] font-bold text-purple-700">Support my Work 🎨</span>
                     <div className="flex gap-1 text-[9px] font-bold text-slate-600 bg-white px-2 py-0.5 rounded border border-purple-200">
                        <span>2€</span>
                        <span>5€</span>
                        <span className="text-[#0061FF]">10€</span>
                     </div>
                  </div>
                  <button className="w-full bg-[#0061FF] text-white text-[10px] font-bold py-2 rounded-xl">
                     Send 10€ to Zoé
                  </button>
               </div>

               {/* Medium / Blog Article Card */}
               <div className="bg-slate-50 border border-slate-200/80 p-4 rounded-2xl space-y-2 text-left">
                  <span className="text-[9px] font-bold text-slate-400 uppercase">Artigo Recente</span>
                  <strong className="text-xs font-bold text-slate-900 block leading-snug">
                     How to Paint Like Hayao Miyazaki
                  </strong>
                  <span className="text-[9px] text-slate-500 block">January 28, 2026</span>
               </div>

               {/* Large Photo Gallery Card */}
               <div className="bg-slate-100 border border-slate-200 rounded-2xl overflow-hidden h-32 relative">
                  <img 
                     src="https://images.unsplash.com/photo-1513694203232-719a280e022f?q=80&w=400&auto=format&fit=crop" 
                     className="w-full h-full object-cover" 
                     alt="Gallery Showcase" 
                  />
               </div>

               {/* LinkedIn Connections Card */}
               <div className="bg-blue-50/60 border border-blue-200/80 p-4 rounded-2xl space-y-2 text-left">
                  <div className="w-7 h-7 rounded-full bg-[#0A66C2] text-white flex items-center justify-center">
                     <Linkedin className="w-3.5 h-3.5" />
                  </div>
                  <strong className="text-xs font-bold text-slate-900 block">LinkedIn</strong>
                  <span className="text-[10px] font-bold text-slate-600 block">387 connections</span>
               </div>

               {/* Figma / Calendar Booking Card */}
               <div className="sm:col-span-3 bg-white border border-slate-200/80 text-slate-900 p-4 rounded-2xl flex items-center justify-between">
                  <div className="flex items-center gap-3">
                     <div className="w-8 h-8 rounded-xl bg-blue-600 text-white flex items-center justify-center font-bold shadow-sm">
                        <Calendar className="w-4 h-4" />
                     </div>
                     <div>
                        <strong className="text-xs font-bold block text-slate-900">Book a 30min Mentorship Call</strong>
                        <span className="text-[10px] text-slate-500">Available slots for this week</span>
                     </div>
                  </div>
                  <button className="bg-[#0061FF] hover:bg-blue-600 text-white text-xs font-bold px-4 py-2 rounded-xl transition-colors shadow-sm">
                     Schedule Now
                  </button>
               </div>

            </div>

         </div>

      </div>

    </div>
  );
};
